// models/produtos/combos/ProdutoConjunto.js
export class ProdutoConjunto {
    constructor(id = 0, conjuntoId = 0, produtoId = 0, conjunto = null, produto = null) {
        this.id = id;
        this.conjuntoId = conjuntoId;
        this.produtoId = produtoId;
        this.conjunto = conjunto; // objeto Conjunto (opcional)
        this.produto = produto;   // objeto Produto (opcional)
    }
}